PJQ.modules.files = {
	routes: [],
};

PJQ.app.addRoutes(PJQ.modules.files.routes);
PJQ.views.files.FileNavigator = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.FILES, 'File-Navigator'),
        subTemplates: {
            file: new PJQ.templating.Template(PJQ.constants.modules.FILES, 'File'),
            fileMenu: new PJQ.templating.Template(PJQ.constants.modules.FILES, 'File-Menu')
        },
        isDeferred: true,
        sortBy: null,
        sortDirection: 'asc',
        expandAllFolders: false,
        expandSharedFolders: false,
        canOrder: true,
        foldersOnly: false
    },
    defaultEvents: {
        'click .btn-add-root-folder': 'addRootFolderClicked',
        'click .attachment-link': 'attachmentLinkClicked',
        'click .attachment': 'attachmentClicked',
        'dblclick .attachment': 'attachmentDblClicked',
        'click .input-select-attachment': 'stopPropagation',
        'change .input-select-attachment': 'attachmentChecked',
        'click .btn-share-selected': 'shareSelected',
        'click .btn-download-selected': 'downloadSelected',
        'click .btn-cut-selected': 'cutSelected',
        'click .btn-copy-selected': 'copySelected',
        'click .btn-delete-selected': 'deleteSelected',
        'click .btn-order-selected': 'orderSelected',
        'click .btn-new-folder': 'addFolderClicked',
        'click .btn-export-file-list': 'exportFileListClicked',
        'click .btn-upload-attachments-root': 'uploadRootAttachmentsClicked',
        'click .btn-upload-attachments': 'uploadToFolderClicked',
        'click .btn-download-attachment': 'downloadAttachmentClicked',
        'click .btn-share-attachment': 'shareAttachmentClicked',
        'click .btn-order-attachment': 'orderAttachmentClicked',
        'click .btn-cut-attachment': 'cutAttachmentClicked',
        'click .btn-copy-attachment': 'copyAttachmentClicked',
        'click .btn-rename-attachment': 'renameAttachmentClicked',
        'click .btn-paste': 'pasteClicked',
        'click .btn-delete-attachment': 'deleteAttachmentClicked',
        'click .btn-attachment-properties': 'attachmentPropertiesClicked',
        'dragenter .attachment': 'attachmentDragEnter',
        'dragleave .attachment': 'attachmentDragLeave',
        'dragstart .attachment': 'attachmentDragStart',
        'dragover .attachment': 'attachmentDragOver',
        'drop .attachment': 'attachmentDrop',
        'click .btn-file-menu': 'renderContextMenu',
        'click .col-label': 'changeSort'
    },
    beforeInit: function () {
        this.expandedFolders = [];
        this.selectedAttachmentIds = [];
        this.highlightedAttachmentIds = [];
    },
    beforeFirstRender: function () {
        this.options.canAdd = PJQ.app.session.hasPermission('documents.canAdd');
        this.options.canShare = PJQ.app.session.hasPermission('documents.canShare') && !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.DISABLE_SHARE_PEI);
        this.options.canOrder = !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.DISABLE_ORDER_PRINT);
        this.options.isAdmin = PJQ.app.session.hasPermission('documents.isAdmin');
        this.fetchAttachments();
    },
    getMenuActions: function () {
        let self = this;
        return [
            {
                name: 'New Folder',
                onClick: function (attachment) {
                    self.addFolder(attachment);
                },
                isShown: function (attachment) {
                    return self.options.isAdmin && attachment.get('isFolder');
                }
            },
            {
                name: 'Upload',
                onClick: function (attachment) {
                    self.uploadToFolder(attachment);
                },
                isShown: function (attachment) {
                    return self.options.canAdd && attachment.get('entryId') > 0 && attachment.get('isFolder');
                }
            },
            {
                name: 'Download',
                onClick: function (attachment) {
                    self.downloadAttachments(attachment);
                }
            },
            {
                name: 'View',
                onClick: function (attachment) {
                    new PJQ.views.files.FileViewer({
                        model: attachment
                    });
                },
                isShown: function (attachment) {
                    return attachment.get('name').toLowerCase().endsWith('.pdf');
                }
            },
            {
                name: 'Order',
                onClick: function (attachment) {
                    self.order(attachment);
                },
                isShown: function () {
                    return !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.DISABLE_ORDER_PRINT);
                }
            },
            {
                name: 'Share',
                onClick: function (attachment) {
                    self.shareAttachments(attachment);
                },
                isShown: function () {
                    return self.options.canShare;
                }
            },
            {
                name: 'Export File List',
                onClick: function (attachment) {
                    self.exportFileList(attachment);
                },
                isShown: function (attachment) {
                    return attachment.get('entryId') > 0 && attachment.get('isFolder');
                }
            },
            {
                name: 'Cut',
                onClick: function (attachment) {
                    self.cutAttachments(attachment);
                },
                isShown: function (attachment) {
                    return self.options.isAdmin && attachment.get('entryId') > 0;
                }
            },
            {
                name: 'Copy',
                onClick: function (attachment) {
                    self.copyAttachments(attachment);
                },
                isShown: function (attachment) {
                    return self.options.isAdmin && attachment.get('entryId') > 0;
                }
            },
            {
                name: 'Paste',
                onClick: function (attachment) {
                    self.paste(attachment);
                },
                isShown: function (attachment) {
                    return self.options.isAdmin && attachment.get('entryId') > 0
                        && attachment.get('isFolder') && self.clipboard != null;
                }
            },
            {
                name: 'Properties',
                onClick: function (attachment) {
                    self.attachmentProperties(attachment);
                },
                isShown: function (attachment) {
                    return !attachment.get('isDrawing') && self.options.isAdmin && attachment.get('entryId') > 0;
                }
            },
            {
                name: 'Rename',
                onClick: function (attachment) {
                    self.renameAttachment(attachment);
                },
                isShown: function (attachment) {
                    return self.options.isAdmin && attachment.get('entryId') > 0;
                }
            },
            {
                name: 'Delete',
                isDanger: true,
                onClick: function (attachment) {
                    self.deleteAttachments(attachment);
                },
                isShown: function (attachment) {
                    return self.options.isAdmin && attachment.get('entryId') > 0 && attachment.get('folderId') > 0;
                }
            }
        ];
    },
    isFetched: function () {
        return this.collection != null && this.collection.isFetched;
    },
    setAllExpanded: function () {
        _.each(this.collection.models, function (attachment) {
            if (this.expandedFolders.indexOf(attachment.cid) === -1 && attachment.get('isFolder') && ((!attachment.get('isDrawing') && attachment.getDepth() <= 1) || attachment.getDepth() <= 0)) {
                this.expandedFolders.push(attachment.cid);
            }
        }, this);
    },
    fetchAttachments: function (options = {isShared: true, isPrivate: true}) {
        if (this.options.project != null && this.options.forShare !== true) {
            this.options.project.fetchAttachments(options, _.bind(function (attachments) {
                this.options.isDeferred = attachments.options.isDeferred;
                if (this.options.isDeferred) {
                    this.$('.ct-selected-attachments').remove();
                }

                this.collection = attachments;
                if (this.options.expandAllFolders) {
                    this.setAllExpanded();
                } else if (this.options.expandSharedFolders) {
                    let sharedFolder = this.collection.findWhere({entryId: -1});
                    if (sharedFolder != null) {
                        this.expandedFolders.push(sharedFolder.cid);
                        this.expandedFolders.push(..._.map(sharedFolder.getFolderAttachments(), function (folder) {
                            return folder.cid;
                        }));
                    }
                }

                this.listenTo(this.collection, 'fetch update', this.renderAttachments);
                this.render();
            }, this));
        } else {
            if (this.collection == null) {
                this.collection = new PJQ.collections.files.Files();
                this.collection.fetch({
                    success: _.bind(function () {
                        if (this.options.expandAllFolders) {
                            this.setAllExpanded();
                        }
                        this.render();
                        this.listenTo(this.collection, 'fetch update', this.renderAttachments);
                    }, this)
                });
            } else {
                this.listenTo(this.collection, 'fetch update', this.renderAttachments);
                this.collection.isFetched = true;
                this.renderAttachments();
            }
        }
    },
    renderData: function () {
        return {
            collection: this.collection,
            canAdd: this.options.canAdd,
            canShare: this.options.canShare,
            canOrder: this.options.canOrder,
            isAdmin: this.options.isAdmin,
            isFetched: this.isFetched(),
            isDeferred: this.options.isDeferred,
            sortBy: this.options.sortBy
        };
    },
    afterRender: function () {
        if (this.isFetched()) {
            this.renderAttachments();
        }
    },
    sortAttachments: function (attachments) {
        let self = this,
            result = attachments.sort(function (a, b) {
                if (self.options.sortBy === "size") {
                    return a.getSize() > b.getSize() ? 1 : -1;
                } else if (self.options.sortBy === "modifiedOn") {
                    return PJQ.helpers.sortHelpers.sortAlphaNum(a.get('modifiedOn'), b.get('modifiedOn'));
                } else if (self.options.sortBy === "name") {
                    return PJQ.helpers.sortHelpers.sortAlphaNum(a.get('name'), b.get('name'));
                } else {
                    let aso = a.get('sortOrder'),
                        bso = b.get('sortOrder');
                    return PJQ.helpers.sortHelpers.sortAlphaNum(aso != null ? aso.toString() : a.get('name'), bso != null ? bso.toString() : b.get('name'));
                }
            });
        return this.options.sortDirection === 'desc' ? result.reverse() : result;
    },
    renderAttachments: function () {
        // if (this.options.sortBy == null) {
        //     this.options.sortBy = "name";
        // }

        let $container = this.$('.attachments-nav'),
            rootAttachments = _.filter(this.collection.models, function (attachment) {
                return attachment.getParentFolder() == null;
            });

        if (this.options.project == null) {
            rootAttachments = this.sortAttachments(rootAttachments);
        } else {
            rootAttachments = _.sortBy(rootAttachments, function (attachment) {
                switch (attachment.get('name').toLowerCase()) {
                    case 'drawings':
                        return 1;
                    case 'shared':
                        return 2;
                    case 'private':
                        return 3;
                    case 'mall':
                        return 4;
                    case 'attachments':
                        return 5;
                    default:
                        return 0;
                }
            });
        }

        let self = this;
        $container.find('.attachment-folder.expanded').each(function () {
            let cid = $(this).data('cid');
            if (self.expandedFolders.indexOf(cid)) {
                self.expandedFolders.push(cid);
            }
        });
        if (_.size(rootAttachments) > 0) {
            $container.empty();
            //render folders first
            _.each(_.filter(rootAttachments, function (attachment) {
                return attachment.get('isFolder');
            }), function (attachment) {
                this.renderAttachment($container, attachment);
            }, this);
            //render files last
            _.each(_.filter(rootAttachments, function (attachment) {
                return !attachment.get('isFolder');
            }), function (attachment) {
                this.renderAttachment($container, attachment);
            }, this);
            this.initContextMenu();
        }
    },
    renderAttachment: function ($container, attachment, depth = 0) {
        let folderAttachments = this.sortAttachments(attachment.getFolderAttachments());
        this.renderSubTemplate(true, this.options.subTemplates.file, $container, {
            model: attachment,
            isDeferred: this.options.isDeferred,
            options: this.options,
            isAdmin: this.options.isAdmin,
            canAdd: this.options.canAdd,
            isSelected: this.selectedAttachmentIds.indexOf(attachment.cid) !== -1,
            isExpanded: this.expandedFolders.indexOf(attachment.cid) !== -1,
            depth: depth
        }, _.bind(function ($folder) {
            if (attachment.get('isFolder')) {
                depth++;
                let $files = $folder.find('.attachment-files').first();
                _.each(_.filter(folderAttachments, function (attachment) {
                    return attachment.get('isFolder');
                }), function (folderAttachment) {
                    this.renderAttachment($files, folderAttachment, depth);
                }, this);

                _.each(_.filter(folderAttachments, function (attachment) {
                    return !attachment.get('isFolder');
                }), function (folderAttachment) {
                    this.renderAttachment($files, folderAttachment, depth);
                }, this);
            }
        }, this));
    },
    renderContextMenu: function (e) {
        let $target = $(e.currentTarget),
            $menu = $target.closest('.btn-group').find('.dropdown-menu'),
            $attachment = $target.closest('.attachment'),
            attachment = this.collection.get($attachment.data('cid')),
            depth = parseInt($attachment.data('depth'));
        this.renderSubTemplate(true, this.options.subTemplates.fileMenu, $menu, {
            model: attachment,
            depth: depth,
            canOrder: this.options.canOrder,
            clipboard: this.clipboard,
            foldersOnly: this.options.foldersOnly,
            canShare: this.options.canShare,
            isAdmin: this.options.isAdmin,
            canAdd: this.options.canAdd,
        });
    },
    initContextMenu: function () {
        let $container = this.$('.attachments-nav');
        new PJQ.menus.ContextMenu({
            el: $container,
            selector: '.attachment',
            actions: this.getMenuActions(),
            fetchElementData: _.bind(function (element) {
                return this.collection.get($(element).data('cid'));
            }, this),
            onOpen: _.bind(function (attachment) {
                this.getAttachmentElement(attachment).addClass('context-attachment');
            }, this),
            onClose: _.bind(function () {
                this.$('.context-attachment').removeClass('context-attachment');
            }, this)
        });
    },
    changeSort: function (e) {
        let $target = $(e.currentTarget),
            newSort = $target.data('attr');
        if (newSort !== this.options.sortBy || this.options.sortDirection === 'desc') {
            this.options.sortDirection = 'asc';
        } else {
            this.options.sortDirection = 'desc';
        }
        this.options.sortBy = newSort;

        this.$('.fa-long-arrow-up,.fa-long-arrow-down').removeClass('active');
        if (this.options.sortDirection === 'asc') {
            $target.parent('div').find('.fa-long-arrow-down').addClass('active');
        } else {
            $target.parent('div').find('.fa-long-arrow-up').addClass('active');
        }

        this.renderAttachments();
    },
    getAttachmentElement: function (attachment) {
        let $aNav = this.$('.attachments-nav');
        if (attachment.cid === -1) {
            return $aNav;
        }
        return $aNav.find('.attachment[data-cid="' + attachment.cid + '"]');
    },
    attachmentLinkClicked: function (e) {
        e.stopPropagation();

        let $attachment = $(e.currentTarget).closest('.attachment'),
            attachment = this.collection.get($attachment.data('cid'));
        if (attachment.get('isFolder')) {
            this.expandFolder($attachment);
        } else {
            if (this.options.project != null && this.options.project.orderSettings != null && this.options.project.orderSettings.get('downloadPerFileFee') > 0) {
                new PJQ.views.files.FileViewer({
                    model: attachment,
                    isDisableDownload: true
                });
            } else if (this.options.orderSettings != null && this.options.orderSettings.downloadPerFileFee > 0) {
                new PJQ.views.files.FileViewer({
                    model: attachment,
                    isDisableDownload: true
                });
            } else if (attachment.get('name').toLowerCase().endsWith('.pdf') && PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.FILE_NAVIGATOR_VIEW_ON_CLICK)) {
                new PJQ.views.files.FileViewer({
                    model: attachment
                });
            } else {
                this.downloadAttachments(attachment);
            }
        }
    },
    attachmentClicked: function (e) {
        let $attachment = $(e.currentTarget).closest('.attachment'),
            attachment = this.collection.get($attachment.data('cid'));
        if (attachment.get('isFolder')) {
            this.expandFolder($attachment);
        }
    },
    attachmentDblClicked: function (e) {
        let $attachment = $(e.currentTarget),
            attachment = this.collection.get($attachment.data('cid'));
        if (attachment.get('isFolder')) {
            this.expandFolder($attachment);
        } else {
            if (this.options.project != null && this.options.project.orderSettings != null && this.options.project.orderSettings.get('downloadPerFileFee') > 0) {
                new PJQ.views.files.FileViewer({
                    model: attachment,
                    isDisableDownload: true
                });
            } else if (this.options.orderSettings != null && this.options.orderSettings.downloadPerFileFee > 0) {
                new PJQ.views.files.FileViewer({
                    model: attachment,
                    isDisableDownload: true
                });
            } else if (attachment.get('name').toLowerCase().endsWith('.pdf') && PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.FILE_NAVIGATOR_VIEW_ON_CLICK)) {
                new PJQ.views.files.FileViewer({
                    model: attachment
                });
            } else {
                this.downloadAttachments(attachment);
            }
        }
    },
    attachmentChecked: function (e) {
        let $checkbox = $(e.currentTarget),
            $attachment = $checkbox.closest('.attachment'),
            attachment = this.collection.get($attachment.data('cid')),
            isChecked = $(e.currentTarget).prop('checked'),
            attachmentIds = [attachment.cid];

        if (attachment.get('isFolder')) {
            attachmentIds.push(..._.map(attachment.getFolderAttachments(true), function (folderAttachment) {
                return folderAttachment.cid;
            }));
            $attachment.siblings('.attachment-files-outer').find('.input-select-attachment').prop('checked', isChecked);
        }

        if (isChecked) {
            this.addSelectedAttachmentIds(attachmentIds);
        } else {
            let parent = attachment.getParentFolder();
            if (parent != null) {
                this.getAttachmentElement(parent).find('.input-select-attachment').prop('checked', false);
                attachmentIds.push(parent.cid);
            }
            this.$('.input-select-all').prop('checked', false);

            this.removeSelectedAttachmentIds(attachmentIds);
        }
    },
    addSelectedAttachmentIds: function (attachmentIds) {
        this.selectedAttachmentIds = _.union(this.selectedAttachmentIds, attachmentIds)
        this.selectedAttachmentsChanged();
    },
    removeSelectedAttachmentIds: function (attachmentIds) {
        this.selectedAttachmentIds = _.difference(this.selectedAttachmentIds, attachmentIds);
        this.selectedAttachmentsChanged();
    },
    selectedAttachmentsChanged: function () {
        let selectedCount = _.size(this.selectedAttachmentIds);
        this.$('.btn-download-selected,.btn-file-actions,.btn-order-selected,.btn-share-selected').prop('disabled', selectedCount === 0);

        if (!this.options.isDeferred) {
            this.$('.ct-selected-attachments').html(selectedCount);
        }

        let selectedAttachments = this.collection.get(this.selectedAttachmentIds);
        let hasDrawings = _.find(selectedAttachments, function (attachment) {
            return attachment.get('isDrawing');
        }) != null;
        if (hasDrawings) {
            this.$('.btn-add-selected-to-drawings,.btn-cut-selected,.btn-copy-selected,.btn-delete-selected').addClass('hidden');
        } else {
            this.$('.btn-add-selected-to-drawings,.btn-delete-selected').removeClass('hidden');

            let hasRootFolder = _.find(selectedAttachments, function (attachment) {
                return attachment.get('folderId') === -1 || !(attachment.get('entryId') > 0);
            }) != null;
            if (hasRootFolder) {
                this.$('.btn-cut-selected,.btn-copy-selected').addClass('hidden');
            } else {
                this.$('.btn-cut-selected,.btn-copy-selected').removeClass('hidden');
            }
        }
    },
    expandFolder: function ($folder, expandOnly = false) {
        let $attachments = $folder.siblings('.attachment-files-outer'),
            isExpanded = $attachments.is(':visible'),
            fnExpand = _.bind(function () {
                if (!isExpanded) {
                    $folder.addClass('expanded');
                    $attachments.animateCSS('slideDown');
                } else if (!expandOnly) {
                    $attachments.animateCSS('slideUp', function () {
                        $folder.css({
                            background: ''
                        });
                    });
                    $folder.removeClass('expanded');
                }
            }, this);
        let folder = this.collection.get($folder.data('cid'));
        if (this.options.isDeferred && !isExpanded && folder.get('entryId') > 0) {
            let fnRender = _.bind(function () {
                if (!$attachments.hasClass('fetched')) {
                    $attachments.addClass('fetched');
                    let $files = $attachments.find('.attachment-files').first(),
                        folderAttachments = folder.getFolderAttachments();
                    $files.empty();
                    _.each(this.sortAttachments(_.filter(folderAttachments, function (attachment) {
                        return attachment.get('isFolder');
                    })), _.bind(function (attachment) {
                        this.renderAttachment($files, attachment, attachment.getDepth());
                    }, this));

                    _.each(this.sortAttachments(_.filter(folderAttachments, function (attachment) {
                        return !attachment.get('isFolder');
                    })), _.bind(function (attachment) {
                        this.renderAttachment($files, attachment, attachment.getDepth());
                    }, this));
                }
                fnExpand();
            }, this);
            if (folder.isFetched) {
                fnRender();
            } else {
                folder.fetchFolderAttachments(null, _.bind(function (files) {
                    if ((this.selectedAttachments != null && this.selectedAttachments.get(folder.cid) != null) || this.selectedAttachmentIds.indexOf(folder.cid) !== -1) {
                        _.each(files, _.bind(function (file) {
                            if (this.selectedAttachments != null) {
                                this.selectedAttachments.add(file);
                            } else {
                                if (this.selectedAttachmentIds.indexOf(file.cid) === -1) {
                                    this.selectedAttachmentIds.push(file.cid)
                                }
                            }
                        }, this));
                    }
                    fnRender();
                }, this));
            }
        } else {
            fnExpand();
        }
    },
    addRootFolderClicked: function () {
        new PJQ.views.files.NewFolderModal({
            folder: new PJQ.models.files.File({
                entryId: -1,
                isFolder: true
            }),
            project: this.options.project,
            onSave: _.bind(function (newFolder) {
                this.collection.add(newFolder);
            }, this)
        });
    },
    addFolderClicked: function (e) {
        let $folder = $(e.currentTarget).closest('.attachment'),
            folder = this.collection.get($folder.data('cid'));
        this.addFolder(folder);
    },
    addFolder: function (folder) {
        new PJQ.views.files.NewFolderModal({
            folder: folder,
            project: this.options.project,
            onSave: _.bind(function (newFolder) {
                this.collection.add(newFolder);
            }, this)
        });
    },
    uploadRootAttachmentsClicked: function () {
        this.uploadToFolder(new PJQ.models.files.File({
            entryId: -1,
            isFolder: true
        }));
    },
    uploadToFolderClicked: function (e) {
        let $folder = $(e.currentTarget).closest('.attachment'),
            folder = this.collection.get($folder.data('cid'));
        this.uploadToFolder(folder);
    },
    uploadToFolder: function (folder) {
        if (!folder.get('isFolder')) {
            return;
        }

        new PJQ.views.files.FileUploaderModal({
            project: this.options.project,
            folder: folder,
            onDone: async (files) => {
                if (PJQ.app.session && PJQ.app.options.useBlobStorage) {

                }

                let successFiles = [];
                _.each(files, function (file) {
                    if (file.get('status') !== 'success' && !file.get('isFolder')) {
                        return;
                    }

                    file.collection = null;
                    if (null == _.find(files, function (fi) {
                        return file.get('folderId') === fi.get('entryId');
                    })) {
                        file.set('folderId', folder.get('entryId'));
                    }
                    successFiles.push(file);
                });
                if (folder.get('entryId') === -1 || folder.isFetched || !this.options.isDeferred) {
                    this.collection.add(successFiles);
                }
                if (folder.get('entryId') > 0) {
                    this.expandFolder(this.getAttachmentElement(folder), true);
                }
            }
        });
    },
    shareAttachmentClicked: function (e) {
        let $attachment = $(e.currentTarget).closest('.attachment'),
            attachment = this.collection.get($attachment.data('cid'));
        this.shareAttachments(attachment);
    },
    shareSelected: function () {
        this.shareAttachments(this.collection.get(this.selectedAttachmentIds));
    },
    shareAttachments: function (attachment) {
        let shareAtt = [],
            fnCheck = function (att) {
                if (att.get('entryId') === -1) {
                    shareAtt.push(...att.getFolderAttachments());
                } else {
                    shareAtt.push(att);
                }
            };
        if (PJQ.helpers.objectHelpers.refinedType(attachment) === 'array') {
            _.each(attachment, function (att) {
                fnCheck(att);
            });
        } else {
            fnCheck(attachment);
        }
        let files = new PJQ.collections.files.Files(shareAtt),
            sharingModal = new PJQ.views.sharing.SharingModal({
                onSave: _.bind(function (data) {
                    files.share(data, null, _.bind(function (share) {
                        PJQ.notifications.notify.successNotify({
                            message: 'File share email sent'
                        });
                    }, this));
                }, this)
            });
        files.share(null, null, function (share) {
            let callback = _.bind(sharingModal.urlChanged, sharingModal);
            callback(share.url);
        });
    },
    downloadAttachmentClicked: function (e) {
        let $attachment = $(e.currentTarget).closest('.attachment'),
            attachment = this.collection.get($attachment.data('cid'));
        this.downloadAttachments(attachment);
    },
    downloadSelected: function () {
        this.downloadAttachments(this.collection.get(this.selectedAttachmentIds));
    },
    downloadAll: function () {
        this.downloadAttachments(this.collection.models);
    },
    replaceVersionFolders: function (attachments) {
        let isArray = PJQ.helpers.objectHelpers.refinedType(attachments) === 'array';
        if (isArray || (attachments.get('isFolder') && attachments.get('isDrawing'))) {
            let versionFolders = isArray ? _.filter(attachments, function (attachment) {
                return attachment.get('isFolder') && attachment.get('isDrawing');
            }) : [attachments];
            if (_.size(versionFolders) > 0) {
                if (!isArray) {
                    attachments = [];
                }
                _.each(versionFolders, function (versionFolder) {
                    let versionDrawings = this.collection.getFolderAttachments(versionFolder, true);
                    attachments.push(...versionDrawings);
                }, this);

                attachments = attachments.filter(function (attachment) {
                    return !attachment.get('isDrawing') || (!attachment.get('isFolder') && attachment.get('isDrawing'));
                });
            }
        }
        return attachments;
    },
    downloadAttachments: function (attachments, options) {
        attachments = this.replaceVersionFolders(attachments);

        let objType = PJQ.helpers.objectHelpers.refinedType(attachments),
            hasDrawings;
        if (objType === 'array') {
            hasDrawings = _.find(attachments, function (attachment) {
                return attachment.id < -1 && !attachment.get('isFolder');
            }) != null;
            attachments = _.uniq(attachments);
        } else if (objType === 'backboneCollection') {
            hasDrawings = _.find(attachments.models, function (attachment) {
                return attachment.id < -1 && !attachment.get('isFolder');
            }) != null;
            attachments = _.uniq(attachments);
        } else {
            hasDrawings = attachments.id < -1 && !attachments.get('isFolder');
        }

        if (this.options.project != null && (this.options.forShare !== true || hasDrawings)) {
            if (this.options.project.orderSettings == null && this.options.orderSettings != null)
                this.options.project.orderSettings = PJQ.helpers.objectHelpers.refinedType(this.options.orderSettings, true) === 'backboneModel' ? this.options.orderSettings : new PJQ.models.BaseModel(this.options.orderSettings);

            this.options.project.checkDownloadRequirements(_.bind(function () {
                if (!options)
                    options = {project: this.options.project};

                if (!options.project)
                    options.project = this.options.project;

                this.options.project.downloadAttachments(attachments, options);
            }, this));
        } else if (this.options.orderSettings != null && this.options.orderSettings.downloadPerFileFee > 0 && !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.IS_DOCUMENT_CLERK)) {
            let ids = [],
                entryIds = [],
                objType = PJQ.helpers.objectHelpers.refinedType(attachments, true),
                fnCheck = function (att) {
                    if (att.get('entryId') === -1) {
                        ids.push(..._.map(att.getFolderAttachments(), function (folderAtt) {
                            return folderAtt.id;
                        }));

                        _.each(att.getFolderAttachments(), function (folderAtt) {
                            if (!folderAtt.get('isFolder')) {
                                entryIds.push(folderAtt.get('isDrawing') ? folderAtt.get('drawingId') * -1 : folderAtt.get('entryId'));
                            }
                        });
                    } else {
                        ids.push(att.id);

                        if (!att.get('isFolder')) {
                            entryIds.push(att.get('isDrawing') ? att.get('drawingId') * -1 : att.get('entryId'));
                        }

                    }
                };
            if (objType === 'backboneCollection') {
                _.each(attachments.models, function (attachment) {
                    fnCheck(attachment);
                });
                attachments = _.uniq(attachments);
            } else if (objType === 'array') {
                _.each(attachments, function (attachment) {
                    fnCheck(attachment);
                });
                attachments = _.uniq(attachments);
            } else {
                fnCheck(attachments);
            }

            if (this.options.project != null && this.options.project.get('masterUserId') === PJQ.app.session.get('masterUserId') && (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.CAN_ORDER_ON_ACCOUNT) || PJQ.app.session.hasPermission('documents.onAccount'))) {
                new PJQ.views.drawings.OrderDownloadAdmin({
                    entryIds: entryIds,
                    orderSettings: this.options.orderSettings
                });
            } else {
                new PJQ.views.files.OrderPrintsModal({
                    mode: PJQ.constants.files.modes.DOWNLOAD,
                    files: attachments,
                    orderSettings: this.options.orderSettings,
                    collection: (this.options.project == null && this.options.collection != null) ? this.options.collection : null,
                    project: PJQ.app.session.project != null ? PJQ.app.session.project : this.options.project
                });
            }
        } else {
            if (objType === 'backboneCollection' || objType === 'array' || attachments.get('isFolder')) {
                new PJQ.collections.files.Files(attachments).download();
            } else {
                attachments.download();
            }
        }
    },
    copyAttachmentClicked: function (e) {
        let $attachment = $(e.currentTarget).closest('.attachment');
        this.copyAttachments($attachment.data('cid'));
    },
    copySelected: function () {
        this.copyAttachments(this.selectedAttachmentIds);
    },
    copyAttachments: function (attachments) {
        this.clipboard = {
            copy: PJQ.helpers.objectHelpers.refinedType(attachments) === 'array' ? attachments : [attachments]
        };
    },
    cutAttachmentClicked: function (e) {
        let $attachment = $(e.currentTarget).closest('.attachment');
        this.cutAttachments($attachment.data('cid'));
    },
    cutSelected: function () {
        this.cutAttachments(this.selectedAttachmentIds);
    },
    cutAttachments: function (attachments) {
        this.clipboard = {
            cut: PJQ.helpers.objectHelpers.refinedType(attachments) === 'array' ? attachments : [attachments]
        };
    },
    pasteClicked: function (e) {
        let $attachment = $(e.currentTarget).closest('.attachment'),
            attachment = this.collection.get($attachment.data('cid'));
        this.paste(attachment);
    },
    paste: function (destinationAttachment) {
        let isCopy = _.size(this.clipboard.copy) > 0,
            fileCount = isCopy ? _.size(this.clipboard.copy) : _.size(this.clipboard.cut),
            pasteFunc = _.bind(function () {
                if (isCopy) {
                    destinationAttachment.copy(this.collection.get(this.clipboard.copy), {
                        project: this.options.project
                    }, _.bind(function (newAttachments) {
                        if (_.size(newAttachments) > 0) {
                            this.collection.add(newAttachments);
                        }
                    }, this));
                } else {
                    destinationAttachment.move(this.collection.get(this.clipboard.cut), {
                        project: this.options.project
                    }, _.bind(function () {
                        this.renderAttachments();
                    }, this));
                }
                this.clipboard = null;
                this.selectedAttachmentIds = [];
            }, this);

        if (destinationAttachment.get('entryId') > 0) {
            pasteFunc();
        } else {
            new PJQ.views.modals.YesNo({
                header: (isCopy ? "Copy" : "Move") + " File" + (fileCount > 1 ? "s" : ""),
                body: "You are " + (isCopy ? "copying" : "moving") + (fileCount > 1 ? " these files" : " this file") + " to the shared folder root, which will put them in the root of your document center.  Are you sure you want to do this?",
                onYes: function () {
                    pasteFunc();
                }
            });
        }
    },
    renameAttachmentClicked: function (e) {
        let cid = $(e.currentTarget).closest('.attachment').data('cid');
        this.renameAttachment(this.collection.get(cid));
    },
    renameAttachment: function (attachment) {
        new PJQ.views.files.RenameFileModal({
            model: attachment,
            onSave: _.bind(function () {
                this.renderAttachments();
            }, this)
        });
    },
    deleteAttachmentClicked: function (e) {
        let cid = $(e.currentTarget).closest('.attachment').data('cid');
        this.deleteAttachments([this.collection.get(cid)]);
    },
    deleteSelected: function () {
        this.deleteAttachments(this.collection.get(this.selectedAttachmentIds));
    },
    deleteAttachments: function (attachments) {
        let text,
            title = "Confirm Deletion",
            btnText = "Delete",
            isArray = PJQ.helpers.objectHelpers.refinedType(attachments) === 'array',
            isDetach = false;
        if (!isArray && attachments.get('isFolder')) {
            if (attachments.get('folderId') === -1) {
                title = "Detach Folder";
                text = "Are you sure you want to detach this folder from the project?  It will not be deleted from your document center.";
                btnText = "Detach";
                isDetach = true;
            } else {
                text = "Are you sure you want to delete this folder?";
            }
        } else if (_.size(attachments) > 1) {
            text = "Are you sure you want to delete these files?";
        } else {
            text = "Are you sure you want to delete this file?";
        }
        new PJQ.views.modals.DeleteCancel({
            header: title,
            body: text,
            deleteButtonText: btnText,
            onDelete: _.bind(function () {
                let fnCallback = _.bind(function () {
                    _.each(isArray ? attachments : [attachments], function (attachment) {
                        if (attachment.get('isFolder')) {
                            _.each(this.collection.getFolderAttachments(attachment, true), function (folderAttachment) {
                                this.collection.remove(folderAttachment);
                            }, this);
                        }
                        this.collection.remove(attachment);
                    }, this);
                }, this);
                if (isDetach) {
                    //if it gets here, attachments is a single object, not an array
                    attachments.detachFromProject(this.options.project, function () {
                        fnCallback();
                    });
                } else if (!isArray) {
                    attachments.destroy();
                    fnCallback();
                } else {
                    let col = new PJQ.collections.files.Files(attachments);
                    col.destroy(_.bind(function () {
                        fnCallback();
                    }, this));
                }
            }, this)
        });
    },
    attachmentDragStart: function (e) {
        this.draggedAttachment = this.collection.get($(e.target).data('cid'));
    },
    attachmentDragOver: function (e) {
        e.preventDefault();
    },
    attachmentDragEnter: function (e) {
        this.$('.drag-hover').removeClass('drag-hover');
        let $target = $(e.target).closest('.attachment-outer');
        if (_.size($target) > 0) {
            let $attachment = $target.find('.attachment').first(),
                targetAttachment = this.collection.get($attachment.data('cid'));
            if ($attachment.hasClass('attachment-folder') && this.draggedAttachment.cid !== targetAttachment.cid &&
                this.draggedAttachment.get('folderId') !== targetAttachment.get('entryId')) {
                this.lastDragOverAttachment = targetAttachment;
                $target.addClass('drag-hover');
            }
        }
    },
    attachmentDragLeave: function (e) {
        let $target = $(e.target).closest('.attachment-outer'),
            $attachment = $target.find('.attachment');
        if (_.size($target) > 0) {
            if ($attachment.hasClass('attachment-folder')) {
                let targetCid = $attachment.first().data('cid');
                if (this.lastDragOverAttachment == null || targetCid !== this.lastDragOverAttachment.cid) {
                    $target.removeClass('drag-hover');
                }
            }
        }
    },
    attachmentDrop: function (e) {
        let $target = $(e.target).closest('.attachment-outer'),
            $attachment = $target.find('.attachment').first(),
            destinationAttachment = this.collection.get($attachment.data('cid'));
        if (this.draggedAttachment != null && destinationAttachment != null && destinationAttachment.get('isFolder') &&
            destinationAttachment.get('entryId') !== this.draggedAttachment.get('entryId') &&
            destinationAttachment.get('entryId') !== this.draggedAttachment.get('folderId') &&
            destinationAttachment.get('folderId') !== this.draggedAttachment.get('entryId')) {
            destinationAttachment.move([this.draggedAttachment], {
                project: this.options.project
            }, _.bind(function () {
                this.renderAttachments();
            }, this));
            this.draggedAttachment = null;
        }
    },
    orderSelected: function () {
        let callback = _.bind(function () {
            let selectedAttachments = this.collection.get(this.selectedAttachmentIds),
                fnOrder = _.bind(function () {
                    let orderAtt = [];
                    _.each(selectedAttachments, function (selectedAttachment) {
                        if (selectedAttachment.get('isFolder')) {
                            orderAtt.push(...selectedAttachment.getFolderAttachments(true));
                        } else {
                            orderAtt.push(selectedAttachment);
                        }
                    });
                    this.order(orderAtt);
                }, this);
            if (this.options.isDeferred) {
                this.collection.fetchFoldersAttachments(selectedAttachments, {recursive: true}, _.bind(function () {
                    fnOrder();
                }, this));
            } else {
                fnOrder();
            }
        }, this);

        if (PJQ.app.session.project && PJQ.app.session.project.get('status').toLowerCase() === 'busy') {
            new PJQ.views.modals.YesNo({
                header: "Document(s) Processing",
                body: "Please Note: New documents are currently being processed for this project.  Are you sure you want to place an order?",
                onYes: _.bind(function () {
                    callback();
                }, this)
            });
        } else
            callback();
    },
    orderAttachmentClicked: function (e) {
        let callback = _.bind(function () {
            let cid = $(e.currentTarget).closest('.attachment').data('cid');
            this.order(this.collection.get(cid));
        }, this);

        if (PJQ.app.session.project && PJQ.app.session.project.get('status').toLowerCase() === 'busy') {
            new PJQ.views.modals.YesNo({
                header: "Document(s) Processing",
                body: "Please Note: New documents are currently being processed for this project.  Are you sure you want to place an order?",
                onYes: _.bind(function () {
                    callback();
                }, this)
            });
        } else
            callback();

    },
    exportFileListClicked: function (e) {
        let cid = $(e.currentTarget).closest('.attachment').data('cid');
        this.exportFileList(this.collection.get(cid));
    },
    exportFileList: function (attachment) {
        attachment.exportFileList();
    },
    attachmentPropertiesClicked: function (e) {
        let cid = $(e.currentTarget).closest('.attachment').data('cid');
        this.attachmentProperties(this.collection.get(cid));
    },
    attachmentProperties: function (attachment) {
        attachment.fetchFolderAttachments({recursive: true}, _.bind(function () {
            new PJQ.views.files.FilePropertiesModal({
                model: attachment,
                project: this.options.project
            });
        }, this));
    },
    order: function (attachments) {
        if (PJQ.helpers.objectHelpers.refinedType(attachments) === 'object') {
            attachments = [attachments];
        }

        let self = this;
        let fnOrder = function () {
            let orderAttachments = [];
            _.each(attachments, function (attachment) {
                if (attachment.get('isFolder')) {
                    orderAttachments.push(...attachment.getFolderAttachments(true, {hideFolders: true}));
                } else {
                    orderAttachments.push(attachment);
                }
            });
            new PJQ.views.files.OrderPrintsModal({
                files: _.uniq(orderAttachments),
                collection: (self.options.project == null && self.options.collection != null) ? self.options.collection : null
            });
        };
        if (this.options.isDeferred && _.find(attachments, function (a) {
            return a.get('isFolder') && !a.isFetched;
        }) != null) {
            this.collection.fetchFoldersAttachments(attachments, {recursive: true}, function () {
                fnOrder();
            });
        } else {
            fnOrder();
        }
    }
});

PJQ.views.files.RenameFileModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.FILES, 'Modal-Rename-File'),
        width: '500px'
    },
    events: {
        'keyup .input-name': 'nameChanged',
        'click .btn-save': 'save'
    },
    beforeRender: function () {
        this.renderData = {
            model: this.model
        };
    },
    afterRender: function () {
        this.$('.input-name').focus();
    },
    nameChanged: function (e) {
        if (e.keyCode === 13) {
            this.save();
        }
    },
    save: function () {
        let newName = this.$('.input-name').val();
        if (!this.model.get('isFolder')) {
            newName += this.model.getExtension();
        }

        if (newName !== this.model.get('name')) {
            this.model.save({
                name: newName
            }, {
                success: _.bind(function () {
                    if (typeof this.options.onSave === 'function') {
                        this.options.onSave(this.model);
                    }
                    this.removeModal();
                }, this)
            });
        } else {
            this.removeModal();
        }
    }
});

PJQ.views.files.NewFolderModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.FILES, 'Modal-New-Folder'),
        width: '500px'
    },
    events: {
        'keyup .input-name': 'folderNameChanged',
        'click .btn-add': 'save'
    },
    beforeRender: function () {
        this.model = new PJQ.models.files.File({
            isFolder: true,
            folderGuid: this.options.folder.get('guid'),
            name: ""
        });
        this.renderData = {
            model: this.model
        };
    },
    afterRender: function () {
        this.$('.input-name').focus();
    },
    folderNameChanged: function (e) {
        if (e.keyCode === 13) {
            this.save();
        }
    },
    save: function () {
        let $folderName = this.$('.input-name'),
            folderName = this.$('.input-name').val(),
            folderNameValid = _.size(folderName) > 0;
        PJQ.helpers.inputHelpers.setInputError($folderName, folderNameValid);
        if (!folderNameValid) {
            return;
        }

        let urlOptions;
        if (this.options.project != null) {
            urlOptions = {
                params: [
                    {
                        parameter: 'projectId',
                        value: this.options.project.id
                    }
                ]
            }
        } else {
            urlOptions = null;
        }

        this.model.save({
            name: folderName
        }, {
            urlOptions: urlOptions,
            success: _.bind(function () {
                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(this.model);
                }
                this.removeModal();
            }, this)
        });
    }
});

PJQ.views.files.OrderPrintsModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.FILES, 'Modal-Order-Prints'),
        minWidth: '600px',
        maxWidth: '1400px',
        isSelectRecipients: false,
        onOrderPlaced: null,
        mode: PJQ.constants.files.modes.PRINT,
        subTemplates: {
            orderFolderSelector: new PJQ.templating.Template(PJQ.constants.modules.FILES, 'ordering-folder-selector'),
            orderCalculatedItems: new PJQ.templating.Template(PJQ.constants.modules.FILES, 'ordering-calculated-items')
        },
    },
    events: {
        'change .input-select-recipients': 'selectRecipientsChanged',
        'click .btn-close': 'onCancel',
        'click .btn-save': 'onSave',
        'click .ordering-folder': 'selectFolder',
        'click .select-file': 'fileSelectChanged',
        'click .order-jump-step': 'goToStep',
        'click .view-file': 'viewFile',
        'click .delete-recipient': 'deleteRecipient',
        'click .edit-recipient': 'editRecipient',
        'click .select-all-files': 'selectAllFiles'
    },
    beforeModalCreated: function () {
        this.options.isAdmin = PJQ.app.session.project == null || PJQ.app.session.project.get('masterUserId') === PJQ.app.session.get('masterUserId');
        this.mode = this.options.mode ? this.options.mode : 'PRINTS';
        this.options.maxWidth = this.mode === PJQ.constants.files.modes.ALT_PRINT || (PJQ.app.session.project && PJQ.app.session.project.get('status').toLowerCase() === "busy") ? '1400px' : '600px';

        if (this.mode === PJQ.constants.files.modes.DOWNLOAD && this.options.files != null) {
            // Need this.options.files to be an array.
            if(PJQ.helpers.objectHelpers.refinedType(this.options.files, true) === 'backboneCollection'){
                this.options.files = this.options.files.models;
            }
            if(PJQ.helpers.objectHelpers.refinedType(this.options.files, true) === 'backboneModel'){
                this.options.files = [this.options.files];
            }
            this.options.files = _.filter(this.options.files, function (file) {
                if (file) {
                    // There are cases of Non-Backbone models being passed through.
                    if(PJQ.helpers.objectHelpers.refinedType(file, true) === 'backboneModel') {
                        return !file.get('isFolder')
                    }
                    else{
                        return !file.isFolder
                    }
                }
            }, this)
        }

        if (this.options.files == null) {
            this.options.files = [];
        } else if (PJQ.helpers.objectHelpers.refinedType(this.options.files) !== 'array') {
            this.options.files = [this.options.files];
        }

        if (this.options.isAdmin && _.size(this.options.recipients) > 0) {
            this.options.isSelectRecipients = true;
        }

        // Fetch any updated preferences to make sure all are up to date
        if (PJQ.app.session.contact != null) {
            PJQ.app.session.preferences.fetch();
            if (!PJQ.app.session.contact.isFetched) {
                PJQ.app.session.contact.fetch({
                    success: _.bind(function () {
                        this.render();
                    }, this)
                });
            }
        } else if (PJQ.app.session.user != null) {
            PJQ.app.session.preferences.fetch();
            if (!PJQ.app.session.user.isFetched) {
                PJQ.app.session.user.fetch({
                    success: _.bind(function () {
                        this.render();
                    }, this)
                });
            }
        }
    },
    beforeRender: function () {
        this.createOrder();
    },
    selectRecipientsChanged: function () {
        this.options.isSelectRecipients = this.$('.input-select-recipients').prop('checked');
        this.render();
    },
    createOrder: function () {
        if (this.model == null) {
            this.model = new PJQ.models.files.Order({
                project: PJQ.app.session.project != null ? PJQ.app.session.project : this.options.project,
                description: "",
                poNumber: "",
                notes: "",
                largeFormatBinding: PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ORDER_LARGE_FORMAT_BINDING_TYPE) ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.ORDER_LARGE_FORMAT_BINDING_TYPE) : "STAPLED",
                largeFormatPaperType: PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ORDER_LARGE_FORMAT_PAPER_TYPE) ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.ORDER_LARGE_FORMAT_PAPER_TYPE) : "WHITE BOND",
                largeFormatQuantity: PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ORDER_LARGE_FORMAT_PRINT_SIZE) ? (PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.ORDER_LARGE_FORMAT_PRINT_SIZE) === PJQ.constants.ordering.paperSize.FULL ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.ORDER_LARGE_FORMAT_QUANTITY) : 0 ) : 0,
                smallFormatBinding: PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ORDER_SMALL_FORMAT_BINDING_TYPE) ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.ORDER_SMALL_FORMAT_BINDING_TYPE) : "STAPLED",
                smallFormatQuantity: PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.ORDER_SMALL_FORMAT_QUANTITY) > 0 ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.ORDER_SMALL_FORMAT_QUANTITY) : 1,
                smallFormatPaperType: PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ORDER_SMALL_FORMAT_PAPER_TYPE) ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.ORDER_SMALL_FORMAT_PAPER_TYPE) : "WHITE BOND",
                halfSizeQuantity: PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ORDER_LARGE_FORMAT_PRINT_SIZE) ? (PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.ORDER_LARGE_FORMAT_PRINT_SIZE) === PJQ.constants.ordering.paperSize.HALF ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.ORDER_LARGE_FORMAT_QUANTITY) : 0 ) : 0,
                cdQuantity: 0,
                shippingSpeed: PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ORDER_DELIVER_BY) ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.ORDER_DELIVER_BY) : "Next Day (Morning)",
                files: this.options.files
            });
        }

        if (this.options.isAdmin && this.options.isSelectRecipients) {
            this.model.recipients = new PJQ.collections.contacts.Contacts(this.options.recipients != null ? this.options.recipients : []);
        } else {
            this.model.recipients = null;
            let contact;
            if (PJQ.app.session.contact != null) {
                contact = PJQ.app.session.contact;
            } else if (PJQ.app.session.user != null) {
                contact = PJQ.app.session.user;
            } else {
                contact = new PJQ.models.contacts.Contact();
            }
            this.model.set({
                notifyEmail: contact.get('email'),
                billingCompanyName: contact.get('companyName'),
                billingContactName: contact.get('contactName'),
                billingPhone: contact.get('phone'),
                billingPhoneExtension: contact.get('phoneExtension'),
                billingAddress1: contact.get('address1'),
                billingAddress2: contact.get('address2'),
                billingCity: contact.get('city'),
                billingState: contact.get('state'),
                billingZip: contact.get('zip'),
                billingCountry: contact.get('country') ? contact.get('country') : 'US',
                isDownload: this.mode === PJQ.constants.files.modes.DOWNLOAD
            });
        }
    },
    renderData: function () {
        return {
            isAdmin: this.options.isAdmin,
            isSelectRecipients: this.options.isSelectRecipients,
            mode: this.mode,
            model: this.model,
            price: this.price
        };
    },
    afterRender: function () {
        if (this.model != null) {
            if (this.options.isAdmin && this.options.isSelectRecipients) {
                new PJQ.views.contacts.ContactsSelectInput({
                    el: this.$('.order-recipients'),
                    context: PJQ.app.session.project != null ? PJQ.constants.contacts.contexts.PARTICIPANTS : PJQ.constants.contacts.contexts.CONTACTS,
                    selectedContact: this.model.recipients.models,
                    showSelectorAddress: true,
                    isSingleChoice: false,
                    onChange: _.bind(function (selectedContacts) {
                        this.model.recipients.reset(selectedContacts);
                    }, this)
                });
            } else {
                this.statePicker = new PJQ.inputs.Selectpicker({
                    el: this.$('.contact-edit-state'),
                    noneSelectedText: 'Select Value',
                    defaultValue: this.model.get('billingState'),
                    onChange: _.bind(function (value) {
                        this.model.set('billingState', value.toUpperCase());
                    }, this)
                });
                this.countryChanged();

                new PJQ.inputs.Selectpicker({
                    el: this.$('.contact-edit-country'),
                    noneSelectedText: 'Select Value',
                    defaultValue: _.size(this.model.get('billingCountry')) > 0 ? this.model.get('billingCountry').toLowerCase() : 'us',
                    onChange: _.bind(function (value) {
                        this.model.set('billingCountry', value.toUpperCase());
                        this.model.set('billingZip', '');
                        this.model.set('billingState', '');
                        this.statePicker.setValue('');
                        this.$('.contact-edit-zip').val('');
                        this.countryChanged();
                    }, this)
                });

                PJQ.helpers.inputHelpers.inputMaskPhone(this.$('.contact-edit-phone'));
                PJQ.helpers.inputHelpers.inputMaskPhone(this.$('.contact-edit-fax'));
                PJQ.helpers.inputHelpers.inputMaskPhone(this.$('.contact-edit-cell'));
            }
            new PJQ.views.files.FileSelectInput({
                el: this.$('.order-files'),
                project: this.model.project,
                selectedFiles: this.model.files,
                collection: this.options.collection,
                ignoreFolders: true,
                selectorOptions: {
                    header: 'Select files to order',
                    confirmButton: 'Update Order'
                },
                isShowChangeButton: true,
                onChange: _.bind(function (selectedFiles) {
                    this.model.files = selectedFiles;
                    this.calculateCost();
                }, this)
            });

            new PJQ.inputs.Selectpicker({
                el: this.$('.order-lf-paper'),
                defaultValue: this.model.get('largeFormatPaperType'),
                onChange: _.bind(function (value) {
                    this.model.set('largeFormatPaperType', value.toUpperCase());
                }, this)
            });
            new PJQ.inputs.Selectpicker({
                el: this.$('.order-lf-binding'),
                defaultValue: this.model.get('largeFormatBinding'),
                onChange: _.bind(function (value) {
                    this.model.set('largeFormatBinding', value.toUpperCase());
                }, this)
            });

            new PJQ.inputs.Selectpicker({
                el: this.$('.order-sf-paper'),
                defaultValue: this.model.get('smallFormatPaperType'),
                onChange: _.bind(function (value) {
                    this.model.set('smallFormatPaperType', value.toUpperCase());
                }, this)
            });
            new PJQ.inputs.Selectpicker({
                el: this.$('.order-sf-binding'),
                defaultValue: this.model.get('smallFormatBinding'),
                onChange: _.bind(function (value) {
                    this.model.set('smallFormatBinding', value.toUpperCase());
                }, this)
            });

            new PJQ.inputs.Selectpicker({
                el: this.$('.order-shipping-speed'),
                defaultValue: this.model.get('shippingSpeed'),
                onChange: _.bind(function (value) {
                    this.model.set('shippingSpeed', value.toUpperCase());
                }, this)
            });

            if (this.price == null && this.mode === PJQ.constants.files.modes.DOWNLOAD) {
                this.calculateCost();
            }

            if(this.mode === PJQ.constants.files.modes.ALT_PRINT){
                this.goToStep(1)
                this.renderFolderPicker();
                this.renderAddressBook();
            }

            new PJQ.Binder(this.$el, this.model);
        } else {
            new PJQ.Loader(this.$('.order-loading'));
        }
    },
    deleteRecipient: function(e){
        let target = $(e.currentTarget),
        contactId = target.closest('.card-body').data('id');

    this.model.recipients.remove(contactId);
    this.calculateCost();
    },
    editRecipient: function(e){
        let target = $(e.currentTarget),
            contactId = target.closest('.card-body').data('id');

        new PJQ.views.contacts.BaseEditContactModal({
            model: this.model.recipients.get(contactId),
            onSave: _.bind(function () {
                this.calculateCost();
            }, this)
        });
    },
    selectAllFiles: function(e){
        let isChecked = $(e.currentTarget).prop('checked'),
            fileSelects = this.$('.select-file');

        if(isChecked){
            this.model.files = _.union(this.model.files, this.selectedFolderFiles);
        }
        else{
            _.each(this.selectedFolderFiles, function(file){
                this.model.files = _.without(this.model.files, file);
            }, this)
        }

        fileSelects.prop('checked', isChecked);

        this.$('.order-selected-file-count').text(this.model.files.length);
        this.$('.step-1-continue').attr('disabled', !_.size(this.model.files) > 0);
    },
    viewFile: function(e){
        let target = $(e.currentTarget),
            row = this.filesTable.getRow(target.closest('tr')),
            file = row.data();

        if (file.isImage()) {
            PJQ.app.view.renderPhotoViewer({
                model: file,
                canDownload: false,
                canDelete: false
            });
        }
        else if (file.canRender()) {
            new PJQ.views.files.FileViewer({
                model: file,
                isDisableDownload: true
            });
        }
    },
    renderFolderPicker: function(selectedFolder){
        let fnRender = _.bind(function(){
            this.folders = _.filter(this.attachments.models, function (attachment) {
                let isSecondLevel = false;
                if(attachment.get('isFolder') && attachment.get('entryId') !== -1){
                    let parent = this.attachments.get(attachment.get('folderId'));
                    if(parent){
                        isSecondLevel = parent.get('entryId') === -1 || parent.get('folderId') === 0;
                    }
                }
                return isSecondLevel && _.size(attachment.getFolderAttachments(true, {
                    hideFolders: true
                })) > 0;
            }, this);

            if (selectedFolder) {
                this.selectedFolder = _.find(this.attachments.models, function (folder) {
                    return folder.id === selectedFolder;
                })
            }
            else {
                this.selectedFolder = this.folders[0];
            }

            if(this.selectedFolder){
                this.selectedFolderFiles = _.filter(this.attachments.models, function (attachment) {
                    return attachment.get('folderId') === this.selectedFolder.get('entryId') && !attachment.get('isFolder');
                }, this)
            }

            let templateData = {
                models: this.folders,
                selectedFolder: this.selectedFolder
            }
            this.renderSubTemplate(false, this.options.subTemplates.orderFolderSelector, this.$('.file-folder-selector'), templateData);
            this.renderFilesTable();
        }, this);
        if(this.attachments == null || this.folders == null) {
            this.options.project.fetchAttachments({
                isShared: true,
                isPrivate: false,
                forceRecursive: true
            }, _.bind(function (attachments) {
                this.attachments = attachments;
                fnRender();
            }, this))
        }
        else{
            fnRender();
        }
    },
    renderAddressBook: function(){
        this.addressBookView = new PJQ.views.addressbook.AddressBook({
            el: this.$('.address-book'),
            selectionMode: PJQ.constants.addressBook.selectionMode.ADD_TO_PROJECT,
            disabledContacts: [],
            disabledContactGroups: null,
            onSelection: _.bind(function (contactsAll, contactsNoGroup, contactGroups) {
                this.$('.order-selected-contact-count').text(contactsAll.length);
                this.$('.step-2-continue').attr('disabled', !contactsAll.length > 0);
                this.selectedRecipients = contactsAll;
            }, this)
        });
    },
    renderFilesTable: function () {
        this.filesTable = new PJQ.views.dataTables.DataTable({
            el: this.$(".file-selector-table"),
            data: this.selectedFolderFiles,
            rowId: "cid",
            order: [0, 'asc'],
            language: {
                zeroRecords: 'Folder contains no files'
            },
            pageLength: 50,
            onRowDoubleClick: _.bind(function (row) {

            }, this),
            columns: [
                {
                    "columnData": '',
                    "title": '<div class="pretty p-default p-icon p-smooth fs-18 m-0"><input type="checkbox" class="select-all-files" /><div class="state"><label class="wd-0">&nbsp;</label></div></div>',
                    "width": "20px",
                    "data": "null",
                    "orderable": false,
                    "searchable": false,
                    "render": _.bind(this.renderFileSelect, this)
                },
                {
                    "title": "Name",
                    "data": "attributes.name",
                    "orderable": true
                },
                {
                    "title": "Folder",
                    "data": "",
                    "orderable": true,
                    "render": _.bind(function (data, a, b) {
                        return this.selectedFolder.get('name');
                    }, this)
                },
                {
                    "data": "",
                    "title": "",
                    "orderable": false,
                    "searchable": false,
                    "width": "80px",
                    "render": _.bind(function (data, type, row) {
                        if(row.canRender() || row.isImage()){
                            return '<div class="text-align-right show-on-row-hover"><button type="button" class="btn btn-info view-file ht-30p wd-35p ml-1 fs-14"><span class="fal fa-eye"></span></button></div>';
                        }
                        else{
                            return '';
                        }
                    }, this)
                }
            ]
        });
    },
    selectFolder: function(e){
        let target = $(e.currentTarget);
        this.renderFolderPicker(target.data('id'));
    },
    renderFileSelect: function (data, type, row) {
        let isSelected = _.find(this.model.files, function(file){
            return file.get('entryId') === row.get('entryId')
        }, this) != null

        this.manageSelectAllButtonState();

            return ('<div class="text-align-center"><div class="pretty p-default p-curve fs-22 m-0">' +
                '<input type="checkbox"' + (isSelected  ? ' checked ' : '') + ' class="select-file' + '" />' +
                '<div class="state p-primary"><label class="wd-0">&nbsp;</label></div>' +
                '</div></div>');
    },
    fileSelectChanged: function (e) {
        let tr = $(e.currentTarget).closest('tr'),
            row = this.filesTable.getRow(tr),
            file = row.data();
        if ($(e.currentTarget).prop('checked')) {
            this.model.files.push(file);
        }
        else {
            this.model.files = _.without(this.model.files, file);
        }

        this.manageSelectAllButtonState();
        this.$('.order-selected-file-count').text(this.model.files.length);
        this.$('.step-1-continue').attr('disabled', !_.size(this.model.files) > 0);
    },
    countryChanged: function () {
        let country = this.model.get('billingCountry') && this.model.get('billingCountry').length > 0 ? this.model.get('billingCountry').toLowerCase() : 'us',
            options = '<option value="">Select Value</option>';
        _.each(PJQ.constants.states[country], function (state) {
            options += '<option value="' + state.abbreviation.toLowerCase() + '">' + state.name + '</option>';
        });
        this.statePicker.$el.html(options);
        this.statePicker.refresh();
        if (this.model.get('billingState'))
            this.statePicker.setValue(this.model.get('billingState').toLowerCase());

        PJQ.helpers.inputHelpers.inputMaskZip(this.$('.contact-edit-zip'), country);
    },
    manageSelectAllButtonState: function() {
        let isSelectAll = true;
        _.each(this.selectedFolderFiles, function(row){
            if(isSelectAll){
                isSelectAll = _.find(this.model.files, function(file){
                    return file.get('entryId') === row.get('entryId')
                }, this) != null
            }
        }, this)

        this.$('.select-all-files').prop('checked', isSelectAll);
    },
    goToStep: function (step) {
        if(step.currentTarget){
            this.step = $(step.currentTarget).data('step')
        }
        else{
            this.step = step;
        }
        let thisStep = $('.step-' + this.step.toString()),
            thisStepHeader = $('.step-header-' + this.step.toString());
        this.$('[class*=step-]').not(thisStep).collapse('hide');
        this.$('[class*=step-header-]').not(thisStepHeader).removeClass('text-primary').addClass('text-dark op-4');
        thisStepHeader.removeClass('text-dark op-4').addClass('text-primary');

        if (this.step === 1) {
            this.$('.order-selected-file-count').parent().removeClass('text-dark op-4').addClass('text-info');
            this.$('.order-selected-contact-count').parent().removeClass('text-info').addClass('text-dark op-4');
        }
        else if (this.step === 2) {
            this.$('.order-selected-file-count').parent().removeClass('text-info').addClass('text-dark op-4');
            this.$('.order-selected-contact-count').parent().removeClass('text-dark op-4').addClass('text-info');
        }
        else if (this.step === 3) {
            this.$('.order-selected-contact-count').parent().removeClass('text-info').addClass('text-dark op-4');

            if(this.model.recipients == null){
                this.model.recipients = new PJQ.collections.contacts.Contacts();
            }
            this.model.recipients.reset(_.map(this.selectedRecipients, function(contact, a, b){
                return new PJQ.models.contacts.Contact({
                    contactId: contact,
                    id: contact
                });
            }, this));
            this.calculateCost();
        }


        // don't hide the footer if the project is offline
        let isOnline = false;
        if(!PJQ.app.session.project){
            isOnline = true;
        }
        else if(PJQ.app.session.project && PJQ.app.session.project.get('status').toLowerCase() !== "busy"){
            isOnline = true;
        }

        this.$('.modal-footer').attr('hidden', this.step !== 3 && isOnline);

        thisStep.collapse('show');
    },
    calculateCost: function () {
        this.model.beforeSave();
        let endpoint = this.model.project != null ? [
            {
                endpoint: 'projects',
                value: this.model.project.get('projectId')
            },
            {
                endpoint: 'orders'
            },
            {
                endpoint: this.mode === PJQ.constants.files.modes.ALT_PRINT ? 'calculatemultiple' : 'calculate'
            }
        ] : [
            {
                endpoint: 'orders'
            },
            {
                endpoint: 'calculate'
            }
        ];

        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint(endpoint),
            data: this.model.attributes
        }).post().done(_.bind(function (data) {
            if(this.mode === PJQ.constants.files.modes.ALT_PRINT){
                this.renderCalculatedTotals(data);
            }
            else{
                this.price = data.total * 100;
                this.render();
            }
        }, this)).fail(function (xhr, err, result) {
        });
    },
    renderCalculatedTotals: function(orders) {
        let templateData = {
            orders: orders
        }
        this.renderSubTemplate(false, this.options.subTemplates.orderCalculatedItems, this.$('.calculated-totals'), templateData);
    },
    onCancel: function () {
        this.removeModal();
    },
    onSave: function () {
        let hasError = false;

        if (this.options.isAdmin && this.options.isSelectRecipients) {
            if (_.size(this.model.recipients.models) === 0) {
                hasError = true;
            }
        }
        else if(this.mode === PJQ.constants.files.modes.ALT_PRINT){
            if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ORDER_PO_REQUIRED)) {
                let $po = this.$('.order-po-number');
                PJQ.helpers.inputHelpers.setInputError($po, true);
                if (_.size(this.model.get('poNumber')) === 0) {
                    PJQ.helpers.inputHelpers.setInputError($po, false);
                    hasError = true;
                }
            }
        }
        else{
            let $company = this.$('.contact-edit-company');
            PJQ.helpers.inputHelpers.setInputError($company, true);
            if (_.size($company.val()) === 0) {
                PJQ.helpers.inputHelpers.setInputError($company, false);
                hasError = true;
            }

            let $contact = this.$('.contact-edit-name');
            PJQ.helpers.inputHelpers.setInputError($contact, true);
            if (_.size($contact.val()) === 0) {
                PJQ.helpers.inputHelpers.setInputError($contact, false);
                hasError = true;
            }

            let $address1 = this.$('.contact-edit-address-1');
            PJQ.helpers.inputHelpers.setInputError($address1, true);
            if (_.size($address1.val()) === 0) {
                PJQ.helpers.inputHelpers.setInputError($address1, false);
                hasError = true;
            }

            let $city = this.$('.contact-edit-city');
            PJQ.helpers.inputHelpers.setInputError($city, true);
            if (_.size($city.val()) === 0) {
                PJQ.helpers.inputHelpers.setInputError($city, false);
                hasError = true;
            }

            let $zip = this.$('.contact-edit-zip');
            PJQ.helpers.inputHelpers.setInputError($zip, true);
            if (_.size($zip.val()) === 0) {
                PJQ.helpers.inputHelpers.setInputError($zip, false);
                hasError = true;
            }

            let $state = this.$('select.contact-edit-state');
            PJQ.helpers.inputHelpers.setInputError($state, true);
            if (_.size(this.model.get('billingState')) === 0) {
                PJQ.helpers.inputHelpers.setInputError($state, false);
                hasError = true;
            }

            let $country = this.$('select.contact-edit-country');
            PJQ.helpers.inputHelpers.setInputError($country, true);
            if (_.size(this.model.get('billingCountry')) === 0) {
                PJQ.helpers.inputHelpers.setInputError($country, false);
                hasError = true;
            }

            let $email = this.$('.contact-edit-email');
            PJQ.helpers.inputHelpers.setInputError($email, true);
            if (_.size($email.val()) === 0) {
                PJQ.helpers.inputHelpers.setInputError($email, false);
                hasError = true;
            }

            let $phone = this.$('.contact-edit-phone');
            PJQ.helpers.inputHelpers.setInputError($phone, true);
            if (_.size(this.model.get('billingPhone')) === 0) {
                PJQ.helpers.inputHelpers.setInputError($phone, false);
                hasError = true;
            }
        }

        let $filesError = this.$('.error');
        if (_.size(this.model.files) === 0) {
            this.errorAlert = new PJQ.Alert($filesError, {
                type: 'danger',
                text: 'No files are selected'
            });
            hasError = true;
        }
        else if(this.errorAlert){
            this.errorAlert.destroy();
        }

        if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ORDER_PO_REQUIRED) && this.mode !== PJQ.constants.files.modes.DOWNLOAD) {
            let $po = this.$('.order-po-number');
            PJQ.helpers.inputHelpers.setInputError($po, true);
            if (_.size(this.model.get('poNumber')) === 0) {
                PJQ.helpers.inputHelpers.setInputError($po, false);
                hasError = true;
            }
        }

        if (hasError) {
            this.$('.ordering-error').removeClass('hidden');
        } else {
            this.$('.ordering-error').addClass('hidden');
            this.model.save(null, {
                success: _.bind(function (result) {
                    if (result.get('status') === 'NEW') {
                        PJQ.notifications.notify.successNotify({
                            message: 'Order #' + result.get('orderId') + ' placed successfully'
                        });
                        this.removeModal();

                        if (typeof this.options.onOrderPlaced === 'function') {
                            this.options.onOrderPlaced();
                        }
                    } else {
                        let orderType = this.mode === PJQ.constants.files.modes.DOWNLOAD ? 'Download' : 'OrderPrints';
                        window.location.href = window.location.origin + '/DesktopModules/PanteraModuleGlobal/OrderPayment.aspx?oc=PROJECT_WALLS&o=' + this.model.id + '&ot=' + orderType;
                    }
                }, this)
            });
        }
    }
});

PJQ.models.files.Order = PJQ.models.BaseModel.extend({
    idAttribute: 'orderId',
    endpoint: function () {
        if (this.project != null) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.project.id
                },
                {
                    endpoint: 'orders'
                }
            ])
        }

        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'orders'
            }
        ])
    },
    parse: function (model) {
        if (model == null) {
            return model;
        }

        if (model.project != null) {
            this.project = model.project;
        }

        if (model.files != null) {
            this.files = model.files;
        }

        if (model.recipients != null) {
            this.recipients = model.recipients;
        }

        return model;
    },
    beforeSave: function () {
        this.set({
            entryIds: _.size(this.files) > 0 ? _.map(_.filter(this.files, function (file) {
                if(PJQ.helpers.objectHelpers.refinedType(file, true) === 'backboneModel') {
                    return !file.get('isFolder')
                }
                else{
                    return !file.isFolder
                }
            }), function (file) {
                if(PJQ.helpers.objectHelpers.refinedType(file, true) === 'backboneModel') {
                    return file.get('drawingId') != null ? -file.get('drawingId') : file.get('entryId');
                }
                else{
                    return file.drawingId != null ? -file.drawingId : file.entryId;
                }
            }) : [],
            recipients: this.recipients ? this.recipients.toJSON() : []
        })
    }
});

PJQ.views.files.FileSelector = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.FILES, 'File-Selector'),
		subTemplates: {
			file: new PJQ.templating.Template(PJQ.constants.modules.FILES, 'Selector-File')
		},
		header: 'Select folders to attach',
		confirmButton: 'Attach',
		project: null,
		isDeferred: true,
		minWidth: 400,
		maxWidth: 800,
		fitHeight: true,
		sortBy: 'name',
		foldersOnly: false,
		sortDirection: 'asc',
		selectedAttachmentIds: [],
		selectedEntryIds: [],
		selectedDrawingIds: [],
		disabledAttachmentIds: [],
		mode: null,
		onSave: _.noop
	},
	defaultEvents: {
		'click .attachment-link': 'attachmentClicked',
		'click .attachment-folder': 'folderClicked',
		'click .col-label': 'changeSort',
		'change .input-select-attachment': 'attachmentChecked',
		'click .btn-cancel': 'removeModal',
		'click .btn-save': 'save'
	},
	beforeModalCreated: function () {
		if (_.size(this.options.selectedAttachmentIds) > 0) {
			this.selectedAttachmentIds = this.options.selectedAttachmentIds;
		}
		else {
			this.selectedAttachmentIds = [];
		}

		if (this.options.project != null) {
			let mode = this.options.mode ? this.options.mode.toUpperCase() : 'ALL',
				opts = {
					isPrivate: mode == null || mode === 'ALL' || mode === 'PRIVATE',
					isShared: mode == null || mode === 'ALL' || mode === 'SHARED'
				}

			this.options.project.fetchAttachments(opts, _.bind(function (attachments) {
				this.collection = attachments;

				let selAtt = [];
				_.each(this.options.selectedEntryIds, function (id) {
					let atts = _.filter(this.collection.models, function (att) {
						return att.get('entryId') === id;
					});
					if (_.size(atts) > 0) {
						selAtt.push(..._.map(atts, function(att){
							return att.cid;
						}));
					}
				}, this);
				_.each(this.options.selectedDrawingIds, function (id) {
					let atts = _.filter(this.collection.models, function (att) {
						return att.get('drawingId') === id;
					});
					if (_.size(atts) > 0) {
						selAtt.push(..._.map(atts, function(att){
							return att.cid;
						}));
					}
				}, this);
				this.selectedAttachmentIds = _.union(selAtt, this.selectedAttachmentIds);

				this.listenTo(this.collection, 'update fetch', this.render);
				this.render();
			}, this));
		}
		else {
			if (this.options.collection != null) {
				this.collection = this.options.collection;
				this.listenTo(this.collection, 'update fetch', this.render);
			}
			else {
				this.collection = this.options.collection != null ? this.options.collection : new PJQ.collections.files.Files();
				this.listenTo(this.collection, 'update fetch', this.render);
				this.collection.fetch();
			}
		}
	},
	renderData: function () {
		return {
			collection: this.collection,
			isAdmin: this.options.isAdmin,
			options: this.options
		};
	},
	afterRender: function () {
		if (this.collection != null && this.collection.isFetched) {
			this.renderAttachments();
		}
	},
	changeSort: function (e) {
		let $target = $(e.currentTarget),
			newSort = $target.data('attr');
		if (newSort !== this.options.sortBy || this.options.sortDirection === 'desc') {
			this.options.sortDirection = 'asc';
		}
		else {
			this.options.sortDirection = 'desc';
		}
		this.options.sortBy = newSort;

		this.$('.fa-long-arrow-up,.fa-long-arrow-down').removeClass('active');
		if (this.options.sortDirection === 'asc') {
			$target.parent('div').find('.fa-long-arrow-down').addClass('active');
		}
		else {
			$target.parent('div').find('.fa-long-arrow-up').addClass('active');
		}

		this.renderAttachments();
	},
	sortAttachments: function (attachments) {
		let self = this,
			result = attachments.sort(function (a, b) {
				if (self.options.sortBy === "size") {
					return a.getSize() > b.getSize() ? 1 : -1;
				}
				else if (self.options.sortBy === "modifiedOn") {
					return PJQ.helpers.sortHelpers.sortAlphaNum(a.get('modifiedOn'), b.get('modifiedOn'));
				}
				else {
					return PJQ.helpers.sortHelpers.sortAlphaNum(a.get('name'), b.get('name'));
				}
			});
		return this.options.sortDirection === 'desc' ? result.reverse() : result;
	},
	renderAttachments: function () {
		let $container = this.$('.attachments-nav'),
			expandedFolders = [],
			rootAttachments = _.filter(this.collection.models, function (attachment) {
				return attachment.getParentFolder() == null;
			});

		if (_.size(rootAttachments) === 1 && rootAttachments[0].get('isFolder') && rootAttachments[0].getFolderAttachments() > 0) {
			rootAttachments = rootAttachments[0].getFolderAttachments();
		}

		rootAttachments = this.sortAttachments(rootAttachments);

		$container.find('.attachment-folder.expanded').each(function () {
			expandedFolders.push($(this).data('cid'));
		});
		if (_.size(rootAttachments) > 0) {
			$container.empty();
			_.each(rootAttachments, function (attachment) {
				if (this.options.foldersOnly && !attachment.get('isFolder')) {
					return;
				}

				this.renderAttachment($container, attachment, expandedFolders);
			}, this);
		}
	},
	renderAttachment: function ($container, attachment, expandedFolders, depth = 0) {
		this.renderSubTemplate(true, this.options.subTemplates.file, $container, {
			model: attachment,
			foldersOnly: this.options.foldersOnly,
			isSelected: this.selectedAttachmentIds.indexOf(attachment.cid) !== -1,
			isExpanded: expandedFolders.indexOf(attachment.cid) !== -1,
			isDisabled: (this.options.foldersOnly && !attachment.get('isFolder')) || this.options.disabledAttachmentIds.indexOf(attachment.get('entryId')) !== -1,
			depth: depth,
		}, _.bind(function ($folder) {
			if (attachment.get('isFolder')) {
				depth++;
				let folderAttachments = this.sortAttachments(attachment.getFolderAttachments()),
					$files = $folder.find('.attachment-files').first();
				_.each(folderAttachments, function (folderAttachment) {
					this.renderAttachment($files, folderAttachment, expandedFolders, depth);
				}, this);
			}
		}, this));
	},
	getAttachmentElement: function (attachment) {
		return this.$('.attachments-nav').find('.attachment[data-cid="' + attachment.cid + '"]');
	},
	attachmentClicked: function (e) {
		let $target = $(e.target),
			$attachment = $target.closest('.attachment'),
			attachment = this.collection.get($attachment.data('cid'));
		if (!attachment.get('isFolder')) {
			if(PJQ.app.session.project.orderSettings.get('downloadPerFileFee') > 0 && PJQ.app.session.get('masterUserId') !== PJQ.app.session.project.get('masterUserId')){
				new PJQ.views.files.FileViewer({
					model: attachment,
					isDisableDownload: true
				});
			}
			else{
				attachment.download();
			}
		}
	},
	folderClicked: function (e) {
		let $target = $(e.target);
		if (!$target.hasClass('dropdown-toggle') && !$target.is('input')) {
			this.expandFolder($(e.currentTarget));
		}
	},
	attachmentChecked: function (e) {
		let $checkbox = $(e.currentTarget),
			$attachment = $checkbox.closest('.attachment'),
			attachment = this.collection.get($attachment.data('cid')),
			isChecked = $(e.currentTarget).prop('checked'),
			attachmentIds = [attachment.cid];

		if (attachment.get('isFolder')) {
			attachmentIds.push(..._.map(attachment.getFolderAttachments(true), function (folderAttachment) {
				return folderAttachment.cid;
			}));
			$attachment.siblings('.attachment-files-outer').find('.input-select-attachment').prop('checked', isChecked);
		}

		if (isChecked) {
			this.selectedAttachmentIds.push(...attachmentIds);
		}
		else {
			this.selectedAttachmentIds = _.difference(this.selectedAttachmentIds, attachmentIds);
			this.$('.input-select-all').prop('checked', false);
		}

		this.selectedAttachmentsChanged();
	},
	selectedAttachmentsChanged: function () {
		let selectedCount = _.size(this.selectedAttachmentIds);
		this.$('.btn-download-selected,.btn-file-actions').prop('disabled', selectedCount === 0);

		if (!this.options.isDeferred) {
			this.$('.ct-selected-attachments').html(selectedCount);
		}
	},
	expandFolder: function ($folder, expandOnly = false) {
		let $attachments = $folder.siblings('.attachment-files-outer'),
			isExpanded = $attachments.is(':visible');
		let folder = this.collection.get($folder.data('cid')),
			fnRender = _.bind(function () {
				if (!$attachments.hasClass('fetched')) {
					$attachments.addClass('fetched');
					let $files = $attachments.find('.attachment-files').first();
					if (this.options.project == null) {
						let folderAttachments = this.sortAttachments(folder.getFolderAttachments());
						_.each(folderAttachments, _.bind(function (attachment) {
							this.renderAttachment($files, attachment, [], attachment.getDepth());
						}, this));
					}
				}
				if (!isExpanded) {
					$folder.addClass('expanded');
					$attachments.animateCSS('slideDown');
				}
				else if (!expandOnly) {
					$attachments.animateCSS('slideUp', function () {
						$folder.css({
							background: ''
						});
					});
					$folder.removeClass('expanded');
				}
			}, this);

		if (this.options.project == null) {
			if (folder.isFetched) {
				fnRender();
			}
			else {
				folder.fetchFolderAttachments(null, _.bind(function (files) {
					if (this.selectedAttachmentIds.indexOf(folder.cid) !== -1) {
						_.each(files, _.bind(function (file) {
							if (this.selectedAttachmentIds.indexOf(file.cid) === -1) {
								this.selectedAttachmentIds.push(file.cid)
							}
						}, this));
					}
					fnRender();
				}, this));
			}
		}
		else {
			fnRender();
		}
	},
	save: function () {
		if (typeof this.options.onSave === 'function') {
			this.options.onSave(this.collection.get(this.selectedAttachmentIds));
		}
		this.removeModal();
	}
});

PJQ.views.files.FilePropertiesModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.FILES, 'Modal-File-Properties')
	},
	defaultEvents: {
		'click .btn-download': 'download',
		'click .btn-export-file-list': 'exportFileList'
	},
	beforeModalCreated: function () {
		// if(this.model.get('isFolder')){
		// 	this.model.fetch();
		// }
	},
	renderData: function () {
		return {
			model: this.model
		};
	},
	download: function () {
		if (this.options.project != null) {
			this.options.project.checkDownloadRequirements(_.bind(function () {
				this.options.project.downloadAttachments(this.model);
			}, this));
		}
		else {
			if(this.model.get('isFolder')){
				new PJQ.collections.files.Files(this.model.getFolderAttachments(true)).download();
			}
			else{
				this.model.download();
			}
		}
	},
	exportFileList: function () {
		this.model.exportFileList();
	}
});